import { Actions } from '../../interfaces'

import { PaymentRecipient } from '@/entities/finance'
import create from './create'
import fetch from './fetch'
import find from './find'
import remove from './remove'
import update from './update'

export const actions: Actions = {
  create,
  fetch,
  find,
  remove,
  update,
}

export default {
  Model: { PaymentRecipient },
  actions: { [PaymentRecipient.name]: actions },
}
